export const initPaymentMethod = () => {
	const customerTypeElement = document.querySelector('#PRIVATE');
	customerTypeElement?.addEventListener('change', () => {
		if (customerTypeElement.checked
			&& document.querySelector('#DIRECT_DEBIT')
			&& document.querySelector('#BY_INVOICE')) {

			const directDebitPaymentMethod = document.querySelector('#DIRECT_DEBIT');
			const byInvoicePaymentMethod = document.querySelector('#BY_INVOICE');
			directDebitPaymentMethod.checked = true;
			directDebitPaymentMethod.parentElement.classList.toggle('checked', true);
			byInvoicePaymentMethod.parentElement.classList.toggle('checked', false);
			document.querySelector('.bankAccountNumber').hidden = false;
		}
	});
};

